import React, { Fragment } from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux'
import {
    registrarUsuarioAccion, ingresoUsuarioAccion, obtenerTodosLosUsuarios,
    obtenerContador,
    obtenerUserPorEmail,
} from '../../redux/UsuarioDucks'
import { ObtenerClientes, } from '../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { obtenerSolicitudesWithStatus, obetenerSolicitud, Contadorfc_01PorLogin, ObtenerClientePorLogin } from '../../redux/SolicitudesDucks'
import { obtenerTodasLasSolicitudesWithStatusEnviado, obtenerTodosClientes } from '../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import ArrowBackIcon from '@mui/icons-material/ArrowBackRounded';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
import generateStore from '../../redux/store';
import { ThemeProvider, createTheme } from '@mui/system';
import LogoMagueySVG from '../../img/logotipoComercam.svg';
import './Login.css'; { {/*Estilos para el componente*/ } }
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../redux/AppDucks'
import { obtenerCadenaProductivaPorLogin } from '../../redux/DucksBeneficiario/ClienteDucks';
import moment from 'moment'

function Login(props) {

    const dispatch = useDispatch()
    const fechaHoy = moment().format('YYYY-MM-DD')
    const [alert, setAlert] = useStateIfMounted(false)
    const [errorAgregar, setErrorAgregar] = useStateIfMounted(false)
    const [errorLogin, setErrorLogin] = useStateIfMounted(false)
    const [exito, setExito] = useStateIfMounted(false)

    const [registrar, setRegistrar] = useStateIfMounted(false)

    const [usuario, setUsuario] = useStateIfMounted('')
    const [password, setPassword] = useStateIfMounted('')

    const modoRegistro = (value) => {
        setRegistrar(value)
        setAlert(false)
        setExito(false)
        setErrorAgregar(false)
        setErrorLogin(false)
    }

    const reloadPage = () => {
        window.location.reload()
    }
    const [usuarioValido, setUsuarioValido] = useStateIfMounted(false)
    const [contrasenaValido, setContrasenaValido] = useStateIfMounted(false)
    const [usuarioLong, setUsuarioLong] = useStateIfMounted(false)

    const botonRegistrarUsuario = async () => {

        if (usuario === '' || password === '' || usuario.length < 4) {
            if (usuario === '' || usuario.length < 4) setUsuarioValido(true)
            if (password === '') setContrasenaValido(true)
        } else {
            let fechainscripcion = new Date(fechaHoy).toISOString()
            const res = await dispatch(registrarUsuarioAccion({ usuario, password, fechainscripcion }))
            setUsuario('')
            setPassword('')
            setUsuarioValido(false)
            setContrasenaValido(false)
            if (res) {
                setAlert(true)
                setExito(true)
                setRegistrar(false)
                props.history.push('/login')
            } else {
                setAlert(true)
                setErrorAgregar(true)
            }
        }

    }
    const currentUser = useSelector(store => store.Usuario.data)
    const loginIn = localStorage.getItem('user')

    const validarInicioSesion = () => {
        if (currentUser != null && loginIn != null) {
            props.history.push('/solicitudes')
        }
    }


    const theme = createTheme({
        palette: {
            background: {
                button: '#c88b3e',
            }
        }
    });

    const botonLoginUsuario = async () => {

        if (!usuario.trim()) {
        }
        const res = await dispatch(ingresoUsuarioAccion({ usuario, password }))
        setUsuario('')
        setPassword('')
        if (res) {
            setAlert(true)
            setExito(true)
            const respuesta = await dispatch(obtenerTodosLosUsuarios({ usuario: usuario }))

            let idlogin = respuesta.data.data[0].idlogin
            let num = Number(respuesta)
            await dispatch(actualizarLoadingApp_true())

            await dispatch(obtenerUserPorEmail(usuario))
            if (respuesta.data.data[0].idtipousuario === 1) {
                const contadorLogin = await dispatch(Contadorfc_01PorLogin({ idlogin: idlogin }))
                const contadorBorrador = await dispatch(obtenerContador({ idestatusdesolicitudes: 1, idlogin: idlogin }))
                const contadorEnviado = await dispatch(obtenerContador({ idestatusdesolicitudes: 2, idlogin: idlogin }))
                const contadorRevicion = await dispatch(obtenerContador({ idestatusdesolicitudes: 3, idlogin: idlogin }))
                const contadorAceptado = await dispatch(obtenerContador({ idestatusdesolicitudes: 4, idlogin: idlogin }))
                const contadorDenegado = await dispatch(obtenerContador({ idestatusdesolicitudes: 5, idlogin: idlogin }))
                const contadorCorregidas = await dispatch(obtenerContador({ idestatusdesolicitudes: 6, idlogin: idlogin }))
                if (contadorLogin === 0) {
                    props.history.push('/fc_01')
                } else {
                    if (contadorBorrador > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorEnviado > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorRevicion > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 3, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorAceptado > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 4, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorDenegado > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 5, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                    if (contadorCorregidas > 0) {
                        let idUsuario = idlogin
                        await dispatch(obtenerSolicitudesWithStatus({ status: 6, idLogin: idUsuario }))
                        props.history.push('/solicitudes')
                    }
                }
            }
            if (respuesta.data.data[0].idtipousuario === 2) {
                await dispatch(obtenerTodosClientes())
                const result = await dispatch(obtenerCadenaProductivaPorLogin(idlogin))
                // const cliente = await dispatch(ObtenerClientePorLogin({idlogin:respuesta.data.data[0].idlogin}))
                props.history.push('/solicitudes')

            }
            if (respuesta.data.data[0].idtipousuario === 3) {
                // await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
                props.history.push('/AtencionAClientesComponent')
            }
            if (respuesta.data.data[0].idtipousuario === 7) {
                await dispatch(ObtenerClientes())
                props.history.push('/PanelConsulta')
            }
            if (respuesta.data.data[0].idtipousuario == 9) {
                props.history.push('/PanelComprasComponent')
            }
            if (respuesta.data.data[0].idtipousuario == 10) {
                props.history.push('/PanelComprasComponent')
            }
            await dispatch(actualizarLoadingApp_false())
        } else {
            setAlert(true)
            setErrorLogin(true)
        }

    }
    const botonRecuperar = async () => {
        // props.history.push('/solicitudes')
    }

    return (

        <Fragment>
            {validarInicioSesion()}

            {/* Floating Alerts */}
            {errorLogin && alert &&
                <div className='login-alert-container'>
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert severity='error' onClose={() => setAlert(false)}>El usuario y la contraseña no son correctos verifique e intenta nuevamente</Alert>
                    </Stack>
                </div>
            }
            {errorAgregar && alert &&
                <div className='login-alert-container'>
                    <Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert severity='error' onClose={() => setAlert(false)}>El usuario y contraseña ya existe</Alert>
                    </Stack>
                </div>
            }
            {exito && alert &&
                <div className='login-alert-container'>
                    <Stack sx={{ width: '100%' }} spacing={4}>
                        <Alert onClose={() => setAlert(false)}>Agregado</Alert>
                    </Stack>
                </div>
            }

            <div className='login-wrapper'>
                <div className='login-card'>
                    {/* Left Brand Panel */}
                    <div className='login-brand-panel'>
                        <img className="img-fluid imagenLogin" src={LogoMagueySVG} alt="COMERCAM" />
                        <div className='login-brand-tagline'>COMERCAM</div>
                        <div className='login-brand-subtitle'>Consejo Mexicano Regulador de la Calidad del Mezcal</div>
                    </div>

                    {/* Right Form Panel */}
                    <div className='login-form-panel'>
                        <h1 className='login-title'>
                            {registrar === false ? 'Bienvenido' : 'Crear cuenta'}
                        </h1>
                        <p className='login-subtitle'>
                            {registrar === false
                                ? 'Ingrese sus credenciales para acceder al sistema en línea.'
                                : 'Complete los datos para registrar su cuenta de acceso.'}
                        </p>
                        <div className='login-divider'></div>

                        {/* Email Input */}
                        <div className='login-input-group'>
                            <label>Correo electrónico</label>
                            <input
                                type="email"
                                placeholder="nombre@ejemplo.com"
                                value={usuario}
                                onChange={e => setUsuario(e.target.value)} />
                            {usuarioValido &&
                                <span className='login-error-msg'>El usuario está vacío o no es correcto, intente nuevamente</span>
                            }
                        </div>

                        {/* Password Input */}
                        <div className='login-input-group'>
                            <label>Contraseña</label>
                            <input
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={e => setPassword(e.target.value)} />
                            {contrasenaValido &&
                                <span className='login-error-msg'>La contraseña está vacía, ingrese un dato nuevamente</span>
                            }
                        </div>

                        {/* Action Buttons */}
                        {registrar ? (
                            <div>
                                <button
                                    type='submit'
                                    className='login-btn-primary'
                                    onClick={() => botonRegistrarUsuario()}>Registrar cuenta
                                </button>
                                <button className='login-btn-secondary' onClick={() => modoRegistro(false)}>
                                    ← Volver al inicio de sesión
                                </button>
                            </div>
                        ) : (
                            <div>
                                <button
                                    type='submit'
                                    className='login-btn-primary'
                                    onClick={() => botonLoginUsuario()}>Ingresar
                                </button>
                                <div className='login-link-text'>
                                    ¿Aún no tienes una cuenta?
                                </div>
                                <button onClick={() => modoRegistro(true)} className='login-btn-secondary'>
                                    Crear cuenta nueva
                                </button>
                            </div>
                        )}

                        {/* Footer */}
                        <div className='login-footer'>
                            <p>© {new Date().getFullYear()} COMERCAM. Todos los derechos reservados. <a href="https://comercam-dom.org.mx/">Declaración de Privacidad</a></p>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>

    )
}

export default withRouter(Login)
